import { Button } from "@mui/material";
import Colors from "@src/constants/Colors";
import { EditorContent } from "@tiptap/react";
import styled from "styled-components";

const StyledEditorContent = styled(EditorContent)`
  .tiptap p.is-editor-empty:first-child::before {
    color: ${Colors.neutral_gray_300};
    content: attr(data-placeholder);
    font-size: 14px;
    font-weight: 325;
    float: left;
    height: 0;
    pointer-events: none;
    font-family: Ringside Regular-Book;
  }
  .ProseMirror {
    outline: none;
    color: #21263b;
    line-break: anywhere;
  }
  &.is-editing {
    .ProseMirror {
      color: #d0d2dd;
    }
  }

  p {
    margin: 0;
  }
`;

const StyledButton = styled(Button)`
  &.MuiButtonBase-root {
    padding: 6px;
    text-align: center;
    text-transform: capitalize;
    min-height: unset;
    min-width: unset;
    width: 32px;
    height: 32px;
    box-shadow: none;
    margin-right: 8px;
    background-color: ${Colors.secondary};
    gap: 8px;
    border-radius: 8px;

    &:hover {
      background-color: ${Colors.secondary};
      box-shadow: none;
    }

    &.cancel {
      background: transparent;
      border: 2px solid ${Colors.secondary};
      svg {
        fill: ${Colors.secondary};
      }
    }
  }
`;

const UserTimestamp = styled.p`
  font-family: "Ringside Regular-Light";
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  color: rgb(70, 70, 70);
`;

export { StyledEditorContent, StyledButton, UserTimestamp };
